<app-dialog [size]="DialogSize.SMALL">
  <app-dialog-header [matDialogCloseValue]="undefined" emitCloseEvent="true" (closeDialog)="onClose()">Payment Method</app-dialog-header>

  <div
    *ngIf="shouldShowAchDebitBlockWarning$ | async"
    class="alert text-start d-flex align-items-center justify-content-stretch gap-4 mb-4"
  >
    <p class="w-100 flex-1 color-gold-100">Is your bank blocking ACH transfers?</p>

    <button
      andButton
      color="hyperlink"
      class="color-gold-100 p-0 text-decoration-none"
      (click)="onNavigateToDebitBlockHelpPage()"
    >
      Check Now
    </button>

    <aiwyn-icon name="x" class="icon-color-gold-100 cursor-pointer" (click)="onDismissDebitBlockWarning()"></aiwyn-icon>
  </div>

  <p *ngIf="isCardSelected$ | async" class="color-gray-100 body-300">
    {{ cardRestrictionsHint$ | async }}
  </p>

  <mat-accordion *ngIf="isAchSelected$ | async" class="new-payment-method-expand-info-block">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <div>
          <p class="info-block-title">Connect your bank below for the safest way to pay</p>
          <p class="info-block-subtitle">Learn why this is the most secure</p>
        </div>
      </mat-expansion-panel-header>

      <div class="mt-1 d-flex flex-column gap-4">
        @for (message of SECURE_ACH_INFO_MESSAGES; track message.benefit) {
          <div class="w-100 d-flex align-items-center gap-4">
            <aiwyn-icon name="check-circle" class="icon-color-blue-100"></aiwyn-icon>
            <p class="w-100 flex-1 body-400 color-blue-100">
              <strong class="fw-bold">{{ message.benefit }}</strong>
              {{ message.explanation }}
            </p>
          </div>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion *ngIf="shouldShowDynamicFeesInfoBlock$ | async" class="new-payment-method-expand-info-block mt-4">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <div>
          <p class="info-block-title">Credit Card payments are subject to fees</p>
          <p class="info-block-subtitle">Check all different fess and their amounts</p>
        </div>
      </mat-expansion-panel-header>

      <div class="mt-3 d-flex flex-column gap-6">
        @for (section of dynamicFeesInfoBlockContent$ | async; track section) {
          <div class="d-flex flex-column gap-1">
            <p class="body-300 color-blue-100">When paying with a credit card using <strong>{{ section.currencyCode }}</strong></p>

            @for (fee of section.fees; track fee) {
              <div class="w-100 d-flex justify-content-between">
                <p class="small-300 color-blue-400">{{ fee.type }}</p>
                <p class="body-600 color-blue-100">{{ fee.value | percent : '1.2' }}</p>
              </div>
            }
          </div>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <p *ngIf="shouldShowProcessingFeeHint$ | async" class="color-gray-100 small-300 mt-2">
    {{ processingFeeHint$ | async }}
  </p>

  @if(paymentMethodError$ | async; as error) {
    <app-new-payment-method-failed [error]="error"></app-new-payment-method-failed>
  }

  <ng-container [ngSwitch]="platform$ | async">
    <app-stripe-select-new-payment-method
      #platformSelectNewPaymentMethodTemplate
      *ngSwitchCase="PaymentPlatform.STRIPE"
      [userProvidedEmail]="userProvidedEmail$ | async"
      (dirtied)="dismissValidationErrorMessage()"
    ></app-stripe-select-new-payment-method>
  </ng-container>

  <ng-container *ngIf="canShowAdditionalActionCheckboxes$ | async">
    <mat-checkbox *ngIf="!isSaveRequired()" [formControl]="saveCheckboxControl" data-cy="save-payment-method">
      Save payment method
    </mat-checkbox>

    <mat-checkbox *ngIf="data.userHasSavedPaymentMethods" [formControl]="setAsDefaultCheckboxControl">
      Make this the default for future payments
    </mat-checkbox>
  </ng-container>

  <app-dialog-footer emitCloseEvent="true" (closeDialog)="onClose()">
    <p *ngIf="data.intent === PaymentMethodIntent.PAYMENT" class="small-300 color-gray-400 me-4">You will not be charged yet</p>
    <button
      andButton
      [isLoading]="paymentMethodCreationLoading$ | async"
      (click)="createPaymentMethod()"
      color="primary"
      type="button"
      data-cy="create-payment-method-button"
    >
      {{ data.intent === PaymentMethodIntent.PAYMENT ? 'Continue' : 'Save' }}
    </button>
  </app-dialog-footer>
</app-dialog>
